const sameMachine = (entry, target) =>
  entry.length === target.length && entry.every((el, i) => el === target[i]);

export const selectMachineHandler = (
  option,
  machine,
  extraOption,
  data,
  selectedMachines,
  isMachineSelected,
) => {

  const locationIdx = Object.keys(data).indexOf(option);
  let newSelectedMachine;
  let specLocationIdx;
  let machineIdx;
  let select;
  if (extraOption) {
    specLocationIdx = Object.keys(data[option].subLocations).indexOf(
      extraOption,
    );
    machineIdx = Object.keys(
      data[option].subLocations[extraOption].devices,
    ).indexOf(machine);

    select = !isMachineSelected?.[locationIdx]?.[specLocationIdx]?.[machineIdx];

    newSelectedMachine = select
      ? [...selectedMachines, [option, extraOption, machine]]
      : selectedMachines.filter(
          (el) => !sameMachine(el, [option, extraOption, machine]),
        );
  } else {
    machineIdx = Object.keys(data[option].devices).indexOf(machine);

    select = !isMachineSelected?.[locationIdx]?.[machineIdx];

    newSelectedMachine = select
      ? [...selectedMachines, [option, machine]]
      : selectedMachines.filter((el) => !sameMachine(el, [option, machine]));
  }

  return {
    locationIdx,
    specLocationIdx,
    machineIdx,
    newSelectedMachine,
    select,
  };
};
